<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div style="text-align: center; margin-bottom: 20px;">
      {{deleteStaffPrivilegeInfo.deleteMessage}}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteStaffPrivilegeModel">点错了</el-button>
      <el-button type="primary" @click="deleteStaffPrivilege">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteStaffPrivilege } from '@/api/frame/deleteStaffPrivilegeApi'

export default {
  name: 'DeleteStaffPrivilege',
  data() {
    return {
      dialogVisible: false,
      deleteStaffPrivilegeInfo: {
        _currentStaffId: '',
        _currentPId: '',
        _currentPFlag: '',
        deleteMessage: '',
        errorInfo: ''
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.deleteStaffPrivilegeInfo._currentStaffId = params.staffId
      this.deleteStaffPrivilegeInfo._currentPId = params.pId
      
      if (params.pgId === '-1') {
        this.deleteStaffPrivilegeInfo._currentPFlag = '0'
        this.deleteStaffPrivilegeInfo.deleteMessage = '确定是否删除当前权限'
      } else {
        this.deleteStaffPrivilegeInfo._currentPId = params.pgId
        this.deleteStaffPrivilegeInfo._currentPFlag = '1'
        this.deleteStaffPrivilegeInfo.deleteMessage = '您删除是权限组下权限，会删除整个权限组权限，确认是否删除'
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    deleteStaffPrivilege() {
      const params = {
        userId: this.deleteStaffPrivilegeInfo._currentStaffId,
        pId: this.deleteStaffPrivilegeInfo._currentPId,
        pFlag: this.deleteStaffPrivilegeInfo._currentPFlag,
      }

      deleteStaffPrivilege(params)
        .then(() => {
          this.dialogVisible = false
          this.$emit('loadStaffPrivileges', {
            staffId: this.deleteStaffPrivilegeInfo._currentStaffId
          })
          this.$message.success('删除成功')
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    closeDeleteStaffPrivilegeModel() {
      this.dialogVisible = false
    }
  }
}
</script>